
import { defineComponent, PropType } from 'vue'
import BaseModal from '../reusable/BaseModal.vue'

import { EnrolledFirestoreDoc } from 'types/enrolment'

export default defineComponent({
  components: { BaseModal },
  emits: ['close', 'confirm'],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    companyData: {
      type: Object as PropType<EnrolledFirestoreDoc>,
      required: true,
    },
  },
})
